import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import EditUnitTypeContainer from './containers/edit-unit-type/edit-unit-type.container';
import UnitTypesListContainer from './containers/unit-types-list/unit-types-list.container';
/**
 * function UnitTypeModule components
 */
export const UnitTypeModule: React.FC = () => {
  return (
    <>
      <Route exact path={APP_ROUTES.UNIT_TYPE_MODULE.FULL_PATH}>
        <Redirect to={(APP_ROUTES.UNIT_TYPE_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH} />
      </Route>
      <Route
        path={(APP_ROUTES.UNIT_TYPE_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH}
        component={UnitTypesListContainer}
      />
      <Route
        path={(APP_ROUTES.UNIT_TYPE_MODULE.CHILDREN as RouteConfig).EDIT.FULL_PATH}
        component={EditUnitTypeContainer}
      />
    </>
  );
};
